export function formatBigNumber(num) {
  if (isNaN(num)) {
    return '';
  }
  const sign = num < 0 ? '-' : '';
  const [mantissa, exponent] = Math.abs(num).toString().split('e');
  if (!exponent) {
    return sign + mantissa;
  }
  const exponentValue = parseInt(exponent, 10);
  const [integerPart, decimalPart = ''] = mantissa.split('.');
  if (exponentValue < 0) {
    return sign + '0.' + '0'.repeat(Math.abs(exponentValue) - 1) + integerPart + decimalPart;
  } else {
    return sign + integerPart + decimalPart + '0'.repeat(Math.max(0, exponentValue - decimalPart.length));
  }
}